module.exports = {
  // 服务器接口host, 跨域请求时设置
  apiHost: {
    // 开发环境
    dev: '',
    // fat
    fat: '',
    // fat
    uat: '',
    // fat
    prod: '',
  }[process.env.VUE_APP_RUN_ENV],

  // 福利系统
  welfareHost: {
    // 开发环境
    dev: '', // 'https://moa-test.zmaxis.com',
    // fat
    fat: '',
    // fat
    uat: '',
    // fat
    prod: '',
  }[process.env.VUE_APP_RUN_ENV],

  // 项目部署的子路径，如应用被部署在 https://p-test.zmlearn.com/my-app，则设置为 /my-app
  publicPath: {
    // 开发环境
    development: '/',

    // fat/uat/prod环境
    production: '/',
  }[process.env.NODE_ENV],

  // 发布系统对应的应用ID，埋点使用
  appId: '11874',
};
